import { call, takeLatest, fork } from 'redux-saga/effects';
import queryString from 'querystring';

import { SORT_CHANGE } from '../actions';
import scrollLockSaga from './scroll-lock';

export function* sortChange(action) {
  const qs = queryString.decode(window.location.search.substr(1));

  const sort = action.data.value.replace(/:(asc|desc)$/, '');
  const direction = action.data.value.match(/:(asc|desc)$/);

  qs.sort = sort;
  qs.direction = direction && direction[1];

  if (!direction) {
    delete qs.direction;
  }

  delete qs.offset;

  const url =
    window.location.pathname +
    (Object.keys(qs).length > 0 ? `?${queryString.encode(qs)}` : '');

  const historyFunc = action.data.replaceHistory
    ? window.__history.replace // eslint-disable-line no-underscore-dangle
    : window.__history.push; // eslint-disable-line no-underscore-dangle

  yield call(historyFunc, url);
}

function* mySaga() {
  yield takeLatest(SORT_CHANGE, sortChange);
  yield fork(scrollLockSaga);
}
export default mySaga;
